export const DELIMITERS = [
  { value: ",", label: "Comma" },
  { value: ";", label: "Semicolon" },
  { value: "\t", label: "Tab" },
  { value: "|", label: "Pipe" },
];

/** Parses CSV by RFC 4180: quoted fields may hold delimiters, line breaks and "" for a quote. Blank lines are dropped. */
export function parseCsv(text: string, delimiter: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let start = text.charCodeAt(0) === 0xfeff ? 1 : 0; // Excel's byte order mark
  let field = "";
  let quoted = false;
  let wasQuoted = false;
  let wasQuotedRow = false;
  const endField = (end: number) => {
    row.push(field + text.slice(start, end));
    field = "";
    wasQuoted = false;
  };
  const endRow = () => {
    if (row.length > 1 || row[0] !== "" || wasQuotedRow) rows.push(row);
    row = [];
    wasQuotedRow = false;
  };
  for (let i = start; i < text.length; i++) {
    const c = text[i];
    if (quoted) {
      if (c !== '"') continue;
      field += text.slice(start, i);
      if (text[i + 1] === '"') {
        field += '"';
        i++;
      } else {
        quoted = false;
      }
      start = i + 1;
    } else if (c === '"' && !wasQuoted && field === "" && i === start) {
      quoted = wasQuoted = wasQuotedRow = true;
      start = i + 1;
    } else if (c === delimiter) {
      endField(i);
      start = i + 1;
    } else if (c === "\n" || c === "\r") {
      endField(i);
      endRow();
      if (c === "\r" && text[i + 1] === "\n") i++;
      start = i + 1;
    }
  }
  if (start < text.length || field || row.length || wasQuoted) {
    endField(text.length);
    endRow();
  }
  return rows;
}

/** The delimiter that splits the start of the file into the most columns, the same number on every line. */
export function detectDelimiter(text: string): string {
  const sample = text.slice(0, 64_000);
  let best = { delimiter: ",", score: 0 };
  for (const { value } of DELIMITERS) {
    const rows = parseCsv(sample, value);
    if (sample.length < text.length) rows.pop(); // cut off in the middle
    const columns = rows[0]?.length ?? 0;
    if (columns < 2) continue;
    const score = (columns * rows.filter((r) => r.length === columns).length) / rows.length;
    if (score > best.score) best = { delimiter: value, score };
  }
  return best.delimiter;
}

const NUMBER = /^[-+]?\d+(?:[.,]\d+)?(?:e[-+]?\d+)?$/i;

export function isNumeric(value: string) {
  return NUMBER.test(value.trim());
}

export function toNumber(value: string) {
  return Number(value.trim().replace(",", "."));
}
